.highlight span {
  background-color: var(--color-bg-success-subtle);
}
